
import Layout from '../../hocs/Layout'
import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { reset_password_confirm } from '../../redux/actions/auth'
import { Circles } from 'react-loader-spinner'
import { Navigate, useParams } from 'react-router'
import Logo from '../../media/img/abenergia-logo.png';
import { Row, Col, Button, Card, Form, Container } from "react-bootstrap/";
import { TextInput } from "../../components/inputs/Inputs";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const ResetPasswordConfirm = ({
  reset_password_confirm,
}) => {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [requestSent, setRequestSent] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const {
    register,
    handleSubmit,
    formState: { isValid, errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(
      Yup.object({
        new_password: Yup.string()
          .required("Requerido")
          .min(8, "Mínimo 8 caracteres"),
        re_new_password: Yup.string()
          .required("Requerido")
          .oneOf([Yup.ref('new_password'), null], 'Las contraseñas deben coincidir')
      })
    ),
  });

  const onSubmit = (data) => {
    setLoading(true);
    try {
      const uid = params.uid
      const token = params.token
      reset_password_confirm(uid, token, data.new_password, data.re_new_password)
      setRequestSent(true);
    }
    catch (error) {
    }
    setLoading(false);
  }

  if (requestSent && !loading)
    return <Navigate to='/' />;

  return (
    <Layout>
      <div className="min-vh-100 d-flex align-items-center bg-light">
        <Container>
          <Row className="justify-content-center">
            <Col md={5} lg={4} sm={8} xs={12}>
              <Card className="border-0 shadow-lg rounded-4 overflow-hidden">
                <Card.Header className="bg-white border-bottom-0 pt-5 pb-0 text-center">
                  <h2 className="text-primary fw-bold mb-0">Nueva Contraseña</h2>
                </Card.Header>
                <Card.Body className="p-4 p-md-5">
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-4">
                      <TextInput
                        register={register}
                        name="new_password"
                        label="Nueva Contraseña"
                        type="password"
                        error={errors.new_password?.message}
                        className="mb-3"
                      />
                      <TextInput
                        register={register}
                        name="re_new_password"
                        label="Repetir Contraseña"
                        type="password"
                        error={errors.re_new_password?.message}
                      />
                    </div>

                    <div className="d-grid gap-2">
                      {loading ?
                        <Button
                          className="rounded-pill py-2 shadow-sm"
                          disabled
                        >
                          <div className="d-flex justify-content-center">
                            <Circles
                              type="Oval"
                              color="#fff"
                              width={20}
                              height={20}
                            />
                          </div>
                        </Button> :
                        <Button
                          type="submit"
                          className="rounded-pill py-2 fw-bold shadow-sm"
                          disabled={!isValid}
                        >
                          Confirmar
                        </Button>}
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  )
}

export default connect(null, {
  reset_password_confirm
})(ResetPasswordConfirm)